import { Loader2 } from 'lucide-react'

export function FullscreenLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background" role="status" aria-label="Carregando">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  )
}

export function PageLoader() {
  return (
    <div className="flex flex-1 items-center justify-center py-24" role="status" aria-label="Carregando">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  )
}
